import * as React from "react";
import { Wrench } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי לבית המטופל?",
  answer: <>
        אנו מתחייבים למציאת פתרון והגעת מטפל סיעודי מקצועי לביתכם תוך 5 שעות בלבד מרגע הפנייה. השירות המהיר שלנו ב-
        <Link to="/HomePage" className="text-chart-3 hover:underline">Siudy – סיעוד מיידי</Link>
        {" "}נועד לתת מענה מיידי במצבי חירום או שחרור פתאומי מבית החולים.
      </>
}, {
  question: "האם המטפלים שלכם עוברים הכשרה מקצועית?",
  answer: <>
        בהחלט. כל המטפלים בצוות שלנו עוברים סינון קפדני, בדיקת רקע והכשרות מקצועיות בתחומי הסיעוד. תוכלו לקרוא עוד על הסטנדרטים שלנו ב-
        <Link to="/ProfessionalBlogPage" className="text-chart-3 hover:underline">בלוג המקצועי</Link>
        {" "}שלנו, המפרט על איכות הטיפול בקשישים.
      </>
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: <>
        כן, המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד בכל ימות השנה, כולל שבתות וחגים. אנו מבינים שצורך ב-
        <Link to="/NursingCareNowPage" className="text-chart-3 hover:underline">מטפל סיעודי עכשיו</Link>
        {" "}יכול לעלות בכל רגע נתון, ללא התראה מוקדמת.
      </>
}, {
  question: "באילו ערים אתם מספקים את השירות המהיר?",
  answer: <>
        אנו פועלים בפריסה ארצית רחבה הכוללת את 
        <Link to="/NursingCaregiverInTelAvivWithinFiveHoursPage" className="text-chart-3 hover:underline"> תל אביב</Link>, 
        <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="text-chart-3 hover:underline"> ירושלים</Link>, 
        <Link to="/NursingCareProviderInHaifaWithinHoursPage" className="text-chart-3 hover:underline"> חיפה</Link>, 
        פתח תקווה, נתניה ובאר שבע, עם התחייבות לזמן הגעה מהיר בכל אחד מהמוקדים.
      </>
}, {
  question: "האם אתם מסייעים בהתנהלות מול הביטוח הלאומי?",
  answer: <>
        הצוות המקצועי שלנו מעניק ייעוץ ראשוני והכוונה בנוגע למיצוי זכויות סיעוד מול המוסד לביטוח לאומי. למידע נוסף על התהליך, בקרו ב-
        <Link to="/ProfessionalBlogPage" className="text-chart-3 hover:underline">מדריכי הזכויות</Link>
        {" "}שלנו שיעזרו לכם לעבור את הבירוקרטיה בקלות.
      </>
}, {
  question: "מה קורה אם המטפל אינו מתאים למטופל?",
  answer: <>
        התאמה אישית היא המפתח להצלחה. במידה ונוצר חוסר התאמה מכל סיבה שהיא, אנו נדאג להחלפת המטפל במהירות האפשרית תוך שמירה על רצף טיפולי מלא, כחלק מ-
        <Link to="/NursingCareNowPage" className="text-chart-3 hover:underline">אמנת השירות</Link>
        {" "}שלנו.
      </>
}, {
  question: "אילו סוגי טיפול אתם מציעים?",
  answer: <>
        אנו מציעים מגוון רחב של שירותים: החל מהשגחה לאחר ניתוח, עזרה בפעולות יומיומיות (ADL), ליווי לבדיקות רפואיות ועד לטיפול סיעודי מורכב ארוך טווח. פרטים מלאים ניתן למצוא ב-
        <Link to="/NursingCareNowPage" className="text-chart-3 hover:underline">דף השירותים</Link>
        {" "}שלנו.
      </>
}];
const relatedServices = [{
  title: "ליווי לאחר שחרור",
  description: "סיוע מיידי במעבר מבית החולים לבית, כולל השגחה צמודה וניהול תרופות מקצועי.",
  icon: Wrench
}, {
  title: "ייעוץ והכוונה",
  description: "ליווי משפחות בתהליך קבלת גמלת סיעוד והתאמת סביבת המגורים לצרכי המטופל.",
  icon: Wrench
}];
export default function FaqSection() {
  return <section data-section-id="260552" id="שאלות-נפוצות" className="py-20 md:py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <p className="text-sm md:text-base text-muted-foreground mb-4 font-default">
            כל מה שחשוב לדעת על שירותי סיעוד מיידיים עד הבית
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight">
            שאלות נפוצות של משפחות
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-none bg-muted/20 rounded-lg px-2 md:px-4 transition-colors hover:bg-muted/30" data-index={i}>
                <AccordionTrigger className="px-4 py-5 hover:no-underline data-[state=open]:text-chart-3 [&[data-state=open]>svg]:text-chart-3 text-base md:text-lg font-default font-semibold text-foreground transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-6 text-muted-foreground text-base leading-relaxed font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-24 md:mt-32 max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h3 className="text-2xl md:text-3xl font-default font-bold text-foreground mb-4">
              שירותים משלימים למטופל
            </h3>
            <p className="text-muted-foreground font-default">
              פתרונות סיעוד מקיפים המותאמים אישית לצרכי המשפחה
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {relatedServices.map((service, i) => <div key={i} className="bg-card border border-border/50 rounded-lg p-6 md:p-8 flex gap-5 items-start shadow-md transition-shadow hover:shadow-lg" data-index={i}>
                <div className="bg-muted/30 p-3 rounded-lg shrink-0">
                  <service.icon className="w-5 h-5 text-chart-3" />
                </div>
                <div>
                  <h4 className="font-default font-bold text-foreground text-lg mb-2">
                    {service.title}
                  </h4>
                  <p className="text-sm text-muted-foreground leading-relaxed font-default">
                    {service.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}